import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import BucketComparison from "../components/clarity/BucketComparison";
import TaxIllustrator from "../components/clarity/TaxIllustrator";
import Disclosure from "../components/clarity/Disclosure";
import { BUCKETS } from "../components/clarity/taxBucketContent";
import { track } from "../lib/clarity";

const TAX_DISCLOSURE =
  "Educational content only — not tax, legal, or investment advice. Tax treatment depends on current law, account eligibility, and individual circumstances, and laws can change. No bucket is universally better than another. Roth conversions, policy funding, and annuity purchases can have costs, eligibility requirements, risks, and tax consequences. Life insurance loans and withdrawals reduce cash value and death benefit and can create taxable income if a policy lapses or is a modified endowment contract. Consult a qualified tax professional before acting.";

export default function TaxBuckets() {
  useEffect(() => { track("tax_buckets_view"); }, []);
  return (
    <div data-testid="tax-buckets-page" className="min-h-screen bg-exodus-bg text-exodus-text">
      <Nav />
      <main className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-28 lg:pt-36 pb-24 space-y-24">
        <section className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8 space-y-6">
            <p className="eyebrow rise"><span className="gold-divider" />Education · Tax diversification</p>
            <h1 data-testid="tax-buckets-headline" className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1] rise rise-1">
              The Three Tax Buckets: <span className="gold-text italic">Where your money lives matters.</span>
            </h1>
            <p className="text-base lg:text-lg text-exodus-muted max-w-2xl rise rise-2">
              Every dollar you save falls into a tax category — taxed now, taxed later, or potentially not taxed when accessed, if specific conditions are met. Understanding the difference helps you ask better questions about how your retirement income could be taxed.
            </p>
          </div>
          <div className="lg:col-span-4 grid gap-3 rise rise-3">
            {BUCKETS.map((b) => (
              <div key={b.key} className="flex items-center gap-4 border border-exodus-border p-4">
                <span className="font-display text-3xl" style={{ color: b.color }}>{b.n}</span>
                <span className="text-sm">{b.name}</span>
              </div>
            ))}
          </div>
        </section>

        <BucketComparison />
        <TaxIllustrator />

        <section className="border border-exodus-gold bg-exodus-elevated p-8 sm:p-12 flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="max-w-xl">
            <p className="eyebrow">See your own mix</p>
            <h2 className="font-display text-3xl mt-2">Find out how your savings are spread — and what that may mean for you.</h2>
          </div>
          <Link to="/clarity-score" data-testid="tax-buckets-cta" className="btn-gold shrink-0">Get my Clarity Score <ArrowRight size={16} weight="bold" /></Link>
        </section>
        <Disclosure testid="tax-buckets-disclosure" text={TAX_DISCLOSURE} />
      </main>
      <Footer />
    </div>
  );
}
